import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, CircularProgress, Snackbar, Alert } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ReportFilterModal from './VehicleViewTopBar';
import axios from 'axios';

const VehicleCountLayout = ({ 
  selectedArea,
  selectedCategory,
  selectedDetection,
  onBackToLive
}) => {
  // State to control modal visibility - set to true by default
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(true);
  
  // State to store applied filters
  const [activeFilters, setActiveFilters] = useState({
    areas: ["All"],
    timeFilter: {
      startTime: new Date(new Date().setHours(0, 0, 0, 0)),
      endTime: new Date(new Date().setHours(23, 59, 59, 999))
    }
  });
  
  const [loading, setLoading] = useState(false);
  const [vehicleData, setVehicleData] = useState([]);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'info'
  });

  // Function to handle filter application
  const handleApplyFilters = (filters) => {
    setActiveFilters(filters);
    // Fetch vehicle count data based on filters
    const cameraIps = filters.selectedCameras.map(camera => camera.ip);
  
    const updatedFilters = {
      ...filters,
      cameraIps
    };
    setActiveFilters(updatedFilters);
  };


  // Function to generate PDF report
  const handleGeneratePDF = async () => {
    setIsGeneratingPDF(true);
    try {
      // Get the local timezone offset in minutes (positive for east of UTC, negative for west)
      // getTimezoneOffset() returns the opposite, so we negate it
      const timezoneOffsetMinutes = -new Date().getTimezoneOffset();
      
      const requestData = {
        area: activeFilters.area,
        checkpost: activeFilters.checkpost,
        cameraIps: activeFilters.cameraIps,
        timeFilter: {
          startTime: activeFilters.timeFilter.startTime.toISOString(),
          endTime: activeFilters.timeFilter.endTime.toISOString()
        },
        timezoneOffset: timezoneOffsetMinutes
      };
      console.log("hello")
     
      
      const response = await axios({
        method: 'post',
        url: 'https://122.252.249:186/generate-pdf',
        data: requestData,
        responseType: 'blob'
      });

      console.log(requestData);
      
      // Create a URL for the blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      
      // Create a temporary link and trigger download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'vehicle_report.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      // Show success notification
      setNotification({
        open: true,
        message: 'PDF report generated successfully!',
        severity: 'success'
      });
    } catch (error) {
      console.error('Error generating PDF:', error);
      // Show error notification
      setNotification({
        open: true,
        message: error.response?.status === 404 
          ? 'No data available for the selected filters.' 
          : 'Error generating PDF report. Please try again.',
        severity: 'error'
      });
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  // Format date for display
  const formatDateForDisplay = (date) => {
    return date.toLocaleString();
  };

  // Handle notification close
  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  // Open the filter modal when component mounts


  return (
    <Box sx={{ padding: 3, flexGrow: 1 }}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
       
        <Box sx={{ display: 'flex', gap: 2 }}>
         
        
        </Box>
      </Box>

      {/* Display active filters */}
    

      {/* Results Section */}
    

      {/* Filter Modal */}
      <ReportFilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        onApplyFilters={handleApplyFilters}
      />

      {/* Notification Snackbar */}
      <Snackbar 
        open={notification.open} 
        autoHideDuration={6000} 
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleCloseNotification} 
          severity={notification.severity} 
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default VehicleCountLayout;